import { SectionRowViewModel } from '../section-row-view-models/SectionRowViewModel';

export class SativaHybridIndicaSectionRowViewModel extends SectionRowViewModel {
  constructor() {
    super();
  }
}
